import {
  SocialAccount,
  ContentVisibility,
  AttachmentDetail,
  Seo,
  ConferencePromo,
  LogoImage,
  VideoModule,
} from '@fs/zion-rootstech'
import Link from './Link'
import { GraphicsImage } from './ImageDetail'
import { ExpoVideoDetail } from './VideoDetail'
import CalendarModule from './CalendarModule'
import { ListModule } from './ListModule'
import RichTextModule from './RichTextModule'
import { ExhibitorCategories } from './ExhibitorCategories'

export const DashboardExhibitorDetail = `
  ${ConferencePromo}
  ${LogoImage}
  ${ContentVisibility}
  ${AttachmentDetail}
  ${ExhibitorCategories}
  fragment DashboardExhibitorDetail on ExhibitorDetail {
    companyDescription
    companyWebsite {
      url
    }
    contentLocale
    downloadableResources {
      ...AttachmentDetail
    }
    exhibitorAssociatedUsers
    exhibitorCategories {
      ...ExhibitorCategories
    }
    highResolutionLogo {
      ...AttachmentDetail
    }
    id
    logo {
      ...LogoImage
    }
    name
    promotions {
      ...ConferencePromo
    }
    sourceId
    sponsor
    sponsorLevel
    url
    visibility {
      ...ContentVisibility
    }
    whiteOnTransparentLogo {
      ...AttachmentDetail
    }
  }
`

export const FullExhibitorDetail = `
  ${ConferencePromo}
  ${Link}
  ${ExpoVideoDetail}
  ${LogoImage}
  ${GraphicsImage}
  ${SocialAccount}
  ${ContentVisibility}
  ${CalendarModule}
  ${ListModule}
  ${RichTextModule}
  ${VideoModule}
  ${AttachmentDetail}
  ${Seo}
  ${ExhibitorCategories}
  fragment FullExhibitorDetail on ExhibitorDetail {
    additionalExperiences {
      ...ConferencePromo
    }
    alternateLocales
    companyContactEmail
    companyContactUsPage {
      ...Link
    }
    companyDescription
    companyFaqs {
      ...Link
    }
    companySupportPage {
      ...Link
    }
    companyWebsite {
      ...Link
    }
    content {
      ...CalendarModule
      ...ConferencePromo
      ...ListModule
      ...RichTextModule
      ...VideoModule
    }
    contentLocale
    downloadableResources {
      ...AttachmentDetail
    }
    exhibitorCategories {
      ...ExhibitorCategories
    }
    graphics {
      ...GraphicsImage
    }
    highResolutionLogo {
      ...AttachmentDetail
    }
    id
    logo {
      ...LogoImage
    }
    name
    promotions {
      ...ConferencePromo
    }
    seo {
      ...Seo
    }
    socialAccounts {
      ...SocialAccount
    }
    sponsor
    sponsorLevel
    supportingChat
    url
    visibility {
      ...ContentVisibility
    }
    welcomeVideo {
      ...ExpoVideoDetail
    }
    whiteOnTransparentLogo {
      ...AttachmentDetail
    }
  }
`
